module.exports = "/static/assets/81905fa6829e39ae8fc173589e8cecfb.gif";